module.exports = "#vocab-previous{\n  margin: 1em;\n}\n\n#vocab-next{\n  margin: 1em;\n}\n"